import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { SubscriptionPlanInfo } from '@models/index';

import { HttpService } from '@services/http.service';
import { EndpointParams } from '@models/utils/endpoint-params';
import { finalize } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionPlanInfoService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    private isLoadingSubject = new BehaviorSubject<boolean>(true);

    get isLoading(): Observable<boolean> {
        return this.isLoadingSubject.asObservable();
    }

    search(idSubscriptionPlanPrice: string): Observable<SubscriptionPlanInfo> {
        this.setLoading(true);
        return this.get(`subscription/member/${idSubscriptionPlanPrice}`, this.defaultEndpointParams)
            .pipe(finalize(() => this.setLoading(false)));
    }

    private setLoading(value: boolean): void {
        this.isLoadingSubject.next(value);
    }
}
